<template>
  <div>
    <!--banner-->
    <div class="banner">
      <swiper class="my-swiper" :options="swiperOption">
        <swiper-slide data-swiper-parallax="-23%" data-swiper-parallax-duration="3000">
          <div class="des" style="left: 50%; top: 20%; transform: translate(-50%, 0); text-align: center">
            <h3 data-swiper-parallax="-1000">{{this.$t('home.DataRecoveryExpert')}}</h3>
            <p data-swiper-parallax="-2000">{{this.$t('home.InnovativeSolutions')}}</p>
            <!-- <a data-swiper-parallax="-3000" data-swiper-parallax-duration="600"
               class="banner-link" href="http://cn.mrtlab.com/company" target="_blank">{{this.$t('common.LearnMore')}} >></a> -->
          </div>
          <div class="img-box">
            <img src="../assets/img/banner-1.jpg" alt="">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="des">
            <h3 data-swiper-parallax="-1000">
              {{this.$t('home.AlreadyHave')}}<span style="color: #ff0">90+</span>{{this.$t('home.Country')}}<br>
              {{this.$t('home.Nearly')}}<span style="color: #ff0">5000+</span>{{this.$t('home.User')}}
            </h3>
          </div>
          <div class="img-box">
            <img src="../assets/img/banner-2.jpg" alt="">
          </div>
        </swiper-slide>
        <!-- 分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 前进后退按钮 -->
        <div class="swiper-button-next" slot="pagination"></div>
        <div class="swiper-button-prev" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 产品 -->
    <div class="product">
      <!--<h2>产品</h2>-->
      <div class="product-box">
        <div class="product-common express">
          <div class="des-box">
            <div class="des">
              <h3 v-animate-onscroll="'animate__animated animate__fadeInLeft'">MRT Express</h3>
              <p v-animate-onscroll="'animate__animated animate__fadeInLeft'"><span>{{this.$t('home.Two')}}</span>{{this.$t('home.ExpressPort')}}</p>
              <p v-animate-onscroll="'animate__animated animate__fadeInLeft'">{{this.$t('home.ExpressSupport')}}</p>
              <p v-animate-onscroll="'animate__animated animate__fadeInLeft'">{{this.$t('home.ExpressSATA')}}<span>150MB/s</span></p>
              <p v-animate-onscroll="'animate__animated animate__fadeInLeft'">{{this.$t('home.ExpressIDE')}}<span>66MB/s</span></p>
              <a v-animate-onscroll="'animate__animated animate__fadeInLeft'" class="banner-link" href=https://www.mrtlab.com/products target="_blank">{{this.$t('common.LearnMore')}} >></a>
            </div>
          </div>
          <div class="img-box">
            <img src="../assets/img/product_express.jpg" alt="">
          </div>
        </div>
        <div class="product-common ultra">
          <div class="des-box">
            <div class="des">
              <h3 v-animate-onscroll="'animate__animated animate__fadeInRight'">MRT ULTRA 3.0</h3>
              <p v-animate-onscroll="'animate__animated animate__fadeInRight'"><span>{{this.$t('home.Four')}}</span>{{this.$t('home.ULTRAPort')}}</p>
              <p v-animate-onscroll="'animate__animated animate__fadeInRight'">{{this.$t('home.ULTRASupport')}}</p>
              <p v-animate-onscroll="'animate__animated animate__fadeInRight'">{{this.$t('home.ULTRASATA')}}<span>600MB/s</span></p>
              <p v-animate-onscroll="'animate__animated animate__fadeInRight'">{{this.$t('home.ULTRAIDE')}}</p>
              <a v-animate-onscroll="'animate__animated animate__fadeInRight'" data-swiper-parallax-duration="600" class="banner-link" href=https://www.mrtlab.com/products target="_blank">{{this.$t('common.LearnMore')}} >></a>
            </div>
          </div>
          <div class="img-box">
            <img src="../assets/img/product_ultra.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
    <!--选择MRT-->
    <div class="choice">
      <div class="choice-box">
        <h2 v-animate-onscroll="'animate__animated animate__fadeInUp'">{{this.$t('home.WhyChooseMRT')}}</h2>
        <div class="choice-list">
          <div class="choice-reason" v-animate-onscroll="'animate__animated animate__bounceInLeft'">
            <div>
              <svg t="1626662622210" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="2397" width="64" height="64"><path d="M866 620V470a16 16 0 0 0-16-16H540v-68h107a16 16 0 0 0 16-16V100a16 16 0 0 0-16-16H377a16 16 0 0 0-16 16v270a16 16 0 0 0 16 16h107v68H174a16 16 0 0 0-16 16v150H80a16 16 0 0 0-16 16v212a16 16 0 0 0 16 16h212a16 16 0 0 0 16-16V636a16 16 0 0 0-16-16h-78V510h270v110h-78a16 16 0 0 0-16 16v212a16 16 0 0 0 16 16h212a16 16 0 0 0 16-16V636a16 16 0 0 0-16-16h-78V510h270v110h-78a16 16 0 0 0-16 16v212a16 16 0 0 0 16 16h212a16 16 0 0 0 16-16V636a16 16 0 0 0-16-16zM417 140h190v190H417zM252 808H120V676h132z m326 0H446V676h132z m326 0H772V676h132z" fill="#00af42" p-id="2398"></path></svg>
              <p class="choice-title">{{this.$t('home.DataRecoveryTool')}}</p>
              <p class="choice-dec">{{this.$t('home.DataRecoveryToolDes')}}</p>
            </div>
          </div>
          <div class="choice-reason" v-animate-onscroll="'animate__animated animate__bounceInUp'">
            <div>
              <svg t="1626662872792" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="3436" width="64" height="64"><path d="M832 426.666667h-1.066667C819.84 260.266667 681.173333 128 512 128S204.16 260.266667 193.066667 426.666667h-2.133334C156.16 426.666667 128 454.826667 128 489.6V618.666667c0 35.2 28.8 64 64 64h42.666667c35.2 0 64-28.8 64-64v-128a63.786667 63.786667 0 0 0-62.933334-63.786667C246.613333 283.733333 366.293333 170.666667 512 170.666667s265.386667 113.066667 276.266667 256.213333A63.786667 63.786667 0 0 0 725.333333 490.666667v128c0 26.026667 15.786667 48.426667 38.186667 58.453333-11.093333 34.346667-46.08 104.533333-148.906667 111.573333C605.44 764.16 582.186667 746.666667 554.666667 746.666667h-85.333334c-35.2 0-64 28.8-64 64s28.8 64 64 64h85.333334c28.16 0 51.626667-18.346667 60.373333-43.52 135.466667-8.106667 178.773333-106.88 191.146667-148.48H832c35.2 0 64-28.8 64-64v-128c0-35.2-28.8-64-64-64z m-576 64v128c0 11.733333-9.6 21.333333-21.333333 21.333333H192c-11.733333 0-21.333333-9.6-21.333333-21.333333v-129.066667c0-11.093333 9.173333-20.266667 20.266666-20.266667H234.666667c11.733333 0 21.333333 9.6 21.333333 21.333334z m298.666667 341.333333h-85.333334c-11.733333 0-21.333333-9.6-21.333333-21.333333s9.6-21.333333 21.333333-21.333334h85.333334c11.733333 0 21.333333 9.6 21.333333 21.333334s-9.6 21.333333-21.333333 21.333333z m298.666666-213.333333c0 11.733333-9.6 21.333333-21.333333 21.333333h-42.666667c-11.733333 0-21.333333-9.6-21.333333-21.333333v-128c0-11.733333 9.6-21.333333 21.333333-21.333334h42.666667c11.733333 0 21.333333 9.6 21.333333 21.333334v128z" p-id="3437" fill="#00af42"></path></svg>
              <p class="choice-title">{{this.$t('home.CustomerService')}}</p>
              <p class="choice-dec">{{this.$t('home.CustomerServiceDes')}}</p>
            </div>
          </div>
          <div class="choice-reason" v-animate-onscroll="'animate__animated animate__bounceInRight'">
            <div>
              <svg t="1626662926054" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="4418" width="64" height="64"><path d="M173.077333 362.666667l91.114667-214.677334a65.6 65.6 0 0 1 86.016-34.773333c11.584 4.906667 24.96 10.282667 40.896 16.448 8.277333 3.2 16.789333 6.464 27.904 10.666667 28.202667 10.709333 39.296 14.933333 46.144 17.642666l51.477333-51.669333c28.181333-28.16 74.112-27.946667 102.570667 0.533333l195.925333 195.925334c16.426667 16.426667 23.445333 38.634667 21.056 59.904H896a42.666667 42.666667 0 0 1 42.666667 42.666666v490.666667a42.666667 42.666667 0 0 1-42.666667 42.666667H128a42.666667 42.666667 0 0 1-42.666667-42.666667V405.333333a42.666667 42.666667 0 0 1 42.666667-42.666666h45.077333z m48.96 0h39.104l169.194667-169.770667-27.328-10.389333c-11.2-4.245333-19.818667-7.530667-28.224-10.794667a1459.2 1459.2 0 0 1-42.197333-17.002667 20.522667 20.522667 0 0 0-26.901334 10.88L222.037333 362.666667z m108.842667 0h454.954667a23.509333 23.509333 0 0 0-5.290667-25.322667l-195.925333-195.925333a23.36 23.36 0 0 0-33.024-0.213334L330.88 362.666667zM128 405.333333v490.666667h768V405.333333H128z m597.333333 320a85.333333 85.333333 0 1 1 0-170.666666 85.333333 85.333333 0 0 1 0 170.666666z m0-42.666666a42.666667 42.666667 0 1 0 0-85.333334 42.666667 42.666667 0 0 0 0 85.333334z" fill="#00af42" p-id="4419"></path></svg>
              <p class="choice-title">{{this.$t('home.PaymentMethods')}}</p>
              <p class="choice-dec">{{this.$t('home.PaymentMethodsDes')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- support -->
    <div class="support">
      <div class="support-box">
        <h2 v-animate-onscroll="'animate__animated animate__fadeInUp'">{{this.$t('home.HDDSeriesSupported')}}</h2>
        <div class="support-list">
          <div class="list-item"  v-animate="'fadeInLeft1'">
            <img src="../assets/homepage/brand_1.jpg" alt=""/>
          </div>
          <div class="list-item"  v-animate="'fadeInLeft2'">
            <img src="../assets/homepage/brand_2.jpg" alt=""/>
          </div>
          <div class="list-item"  v-animate="'fadeInRight1'">
            <img src="../assets/homepage/brand_3.jpg" alt=""/>
          </div>
          <div class="list-item"  v-animate="'fadeInRight2'">
            <img src="../assets/homepage/brand_4.jpg" alt=""/>
          </div>
          <div class="list-item"  v-animate="'fadeInLeft3'">
            <img src="../assets/homepage/brand_5.jpg" alt=""/>
          </div>
          <div class="list-item"  v-animate="'fadeInLeft4'">
            <img src="../assets/homepage/brand_6.jpg" alt=""/>
          </div>
          <div class="list-item"  v-animate="'fadeInRight3'">
            <img src="../assets/homepage/brand_7.jpg" alt=""/>
          </div>
          <div class="list-item"  v-animate="'fadeInRight4'">
            <img src="../assets/homepage/brand_8.jpg" alt=""/>
          </div>
        </div>
      </div>
    </div>
    <!-- About US -->
    <div class="about-us">
      <div class="des-box">
        <div class="des">
          <h2 v-animate-onscroll="'animate__animated animate__fadeInUp'">{{this.$t('home.AboutUs')}}</h2>
          <p v-animate-onscroll="'animate__animated animate__fadeInUp'">{{this.$t('home.Company')}}</p>
          <p v-animate-onscroll="'animate__animated animate__fadeInUp'">{{this.$t('home.CompanyMRT')}}</p>
          <p v-animate-onscroll="'animate__animated animate__fadeInUp'">{{this.$t('home.CompanyMRTPro')}}</p>
          <p v-animate-onscroll="'animate__animated animate__fadeInUp'">{{this.$t('home.CompanyFuture')}}</p>
        </div>
        <div class="show-box" id="show-box">
          <div class="show-list">
            <span class="timer">
              <animate-number ref="numYear" mode="manual" duration="1500" from="0" to="18"></animate-number>
            </span>
            <span class="des">{{this.$t('home.Year')}}</span>
          </div>
          <div class="show-list">
            <span class="timer">
              <animate-number ref="numClient" mode="manual" duration="1500" from="0" to="5000"></animate-number>
            </span>
            <span class="des">{{this.$t('home.User')}}</span>
          </div>
          <div class="show-list">
            <span class="timer">
              <animate-number ref="numResellers" mode="manual" duration="1500" from="0" to="14"></animate-number>
            </span>
            <span class="des">{{this.$t('home.Agent')}}</span>
          </div>
          <div class="show-list">
            <span class="timer">
              <animate-number ref="numCountry" mode="manual" duration="1500" from="0" to="90"></animate-number>
            </span>
            <span class="des">{{this.$t('home.Country')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  export default {
    name: 'homePage',
    data() {
      return {
        showTest: true,
        swiperOption: {
          loop: true,
          autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: true
          },
          speed: 500,
          parallax : true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
        },
        bannerList:[{
          id: '1',
          url: require('@/assets/img/banner-1.jpg'),
          title: 'item1',
          des: ''
        }, {
          id: '2',
          url: require('@/assets/img/banner-2.jpg'),
          title: 'item2',
          des: ''
        }, {
          id: '3',
          url: require('@/assets/img/banner-3.jpg'),
          title: 'item3',
          des: ''
        }],
        brandList:[
          {imgUrl:require('@/assets/homepage/brand_1.jpg'),},
          {imgUrl:require('@/assets/homepage/brand_2.jpg')},
          {imgUrl:require('@/assets/homepage/brand_3.jpg')},
          {imgUrl:require('@/assets/homepage/brand_4.jpg')},
          {imgUrl:require('@/assets/homepage/brand_5.jpg')},
          {imgUrl:require('@/assets/homepage/brand_6.jpg')},
          {imgUrl:require('@/assets/homepage/brand_7.jpg')},
          {imgUrl:require('@/assets/homepage/brand_8.jpg')}
        ],
        newsList:''
      }
    },
    components: {},
    created: function () {
      this.getData();
    },
    mounted() {
      this.numAnimate()
    },
    methods: {
      getData(){
          let lang = this.$store.state.lang
          let _this = this;
          if(lang === 'zh'){
            axios.get(this.$store.state.apiBasePath +"/article/limit")
              .then(function (res) {
                let resData = res.data;
                if(resData.code===200){
                  _this.newsList = resData.data;
                }
              });
          }else {
            axios.get(this.$store.state.apiBasePath +"/article/englishLimit")
              .then(function (res) {
                let resData = res.data;
                if(resData.code===200){
                  _this.newsList = resData.data;
                }
              });
          }

        },
      ifShowNumAnimate() {
        const dom = document.getElementById('show-box')
        const { top } = dom.getBoundingClientRect()
        const domH = dom.offsetHeight
        const h = document.documentElement.clientHeight || document.body.clientHeight
        if (top < h && top + domH > 0) {
          // 元素进入浏览器可视窗口，立马执行动画
          this.$refs.numYear.start()
          this.$refs.numClient.start()
          this.$refs.numResellers.start()
          this.$refs.numCountry.start()
          // 动画开始执行后，立马清除scroll事件，防止动画重复执行的问题
          window.removeEventListener('scroll', this.ifShowNumAnimate,false)
        }
      },
      numAnimate() {
        window.addEventListener('scroll', this.ifShowNumAnimate)
      }
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import '../assets/css/varibles';
  @import '../assets/css/mixins';
  // banner
  .banner {
    .img-box {
      #img-optimize(31.25%);
    }
    .des {
      position: absolute;
      top: 10%;
      left: 15%;
      z-index: 999;
      color: #fff;
      span {
        color: @active-color
      }
      h3 {
        margin: 0 0 25px;
        font-size: 50px;
      }
      p {
        margin: 10px 0;
        font-size: 18px;
      }
      a {
        display: inline-block;
        margin-top: 25px;
        padding: 10px 20px;
        font-size: 16px;
        background: @active-color;
        border-radius: 4px;
        color: #fff;
        text-decoration: none;
        &:hover {
          background: @active-color + 20;
        }
      }
    }
    img {
      width: 100%;
      .center-block();
      .img-responsive();
    }
  }
  // product
  .product {
    padding: 0;
    .product-box {
      overflow: hidden;
      margin: 0 auto;
      .product-common {
        display: flex;
        background: #f2f2f2;
        .des-box {
          width: 50%;
          font-size: 14px;
          background: #fff;
          h3 {
            margin: 0 0 20px;
            font-size: 26px;
            font-weight: normal;
          }
          p {
            margin: 15px 0;
            font-size: 15px;
          }
          a {
            display: inline-block;
            padding: 10px 20px;
            background: @active-color;
            color: #fff;
            text-decoration: none;
            border-radius: 4px;
            &:hover {
              background: @active-color + 20;
            }
          }
          span {
            color: @active-color;
            font-weight: bold;
          }
        }
        .img-box {
          width: 50%;
          background: #fff;
          img {
            .center-block();
            .img-responsive()
          }
        }
      }
      .express {
        padding: 10px 10px 5px;
        .des-box {
          margin-right: 10px;
          text-align: right;
          .des {
            padding: 8% 20% 0 0;
          }
        }
      }
      .ultra {
        padding: 5px 10px 10px;
        .des-box {
          order: 1;
          margin-left: 10px;
          .des {
            padding: 8% 0 0 20%;
          }
        }
      }
    }
  }
  // 选择MRT
  .choice {
    background: #fff;
    padding: 90px 0;
    overflow: hidden; // 防止动画元素执行时产生不必要的滚动条
    .choice-box{
      width: 1170px;
      margin: 0 auto;
      text-align: center;
      h2 {font-size: 36px; font-weight: normal;}
      .choice-list {display: flex;justify-content: space-around;}
      .choice-reason{width: 33.33%;margin: 40px 20px 0;}
      .choice-title {font-size: 20px;line-height:20px;color: @base-color;}
      .choice-dec{font-size:14px;line-height: 22px;color: #888;}
    }
  }
  // support
  .support {
    padding: 90px 0;
    border-top: 5px solid @border-color;
    .support-box {
      overflow: hidden;
      width: 1170px;
      margin: 0 auto;
      text-align: center;
      h2 {
        margin: 40px 0;
        font-size: 36px;
        font-weight: normal;
      }
      .support-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .list-item {
          padding: 5px;
          width: 25%;
          box-sizing: border-box;
          img {
            .center-block();
            .img-responsive();
          }
        }
      }
    }
  }
  // About US
  .about-us {
    padding: 90px 0;
    border-top: 5px solid @border-color;
    .des-box {
      width: 1170px;
      margin: auto;
      text-align: center;
      .des {
        h2 {
          margin: 40px 0;
          font-size: 36px;
          font-weight: normal;
        }
        p {
          font-size: 16px;
          line-height: 24px;
          margin: 16px 0 0;
        }
      }
      .show-box {
        display: flex;
        margin-top: 30px;
        .show-list {
          box-sizing: border-box;
          text-align: center;
          width: 200px;
          height: 200px;
          margin: 0 auto;
          border-radius: 50%;
          border: 3px solid @border-color;
          font-size: 24px;
          color: #666;
          .timer {
            display: block;
            margin-top: 60px;
            font-size: 36px;
            color: #cf0f32;
          }
        }
      }
    }
  }

  // 不同屏幕分辨率样式调整
  @media screen and (max-width: 1170px) {
    .banner {
      .des h3 {
        font-size: 40px;
      }
      .des p {
        font-size: 16px;
      }
    }
    .product {
      .product-box {
        .product-common .des-box {
          h3 {
            font-size: 20px;
          }
          p {
            font-size: 14px;
          }
        }
        .express .des-box {
          margin-right: 10px;
          .des {
            padding: 6% 8% 0 0;
          }
        }
        .ultra .des-box {
          margin-left: 10px;
          .des {
            padding: 6% 0 0 8%;
          }
        }
      }
    }
    .choice {
      padding: 50px 0;
      .choice-box {
        width: 100%;
        h2 {
          font-size: 30px;
        }
        .choice-title {
          font-size: 18px;
        }
      }
    }
    .support {
      padding: 50px 0;
      .support-box {
        width: 100%;
        h2 {
          font-size: 30px;
        }
      }
    }
    .about-us {
      padding: 50px 0;
      .des-box {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        .des {
          h2 {
            font-size: 30px;
          }
          p {
             font-size: 14px;
           }
        }
        .show-box {
          .show-list {
            font-size: 20px;
            .timer {
              font-size: 30px;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .banner {
      .des h3 {
        font-size: 30px;
        margin-bottom: 15px;
      }
      .des p {
        font-size: 14px;
      }
      .des a {
        margin-top: 15px;
        font-size: 12px;
        padding: 8px 15px;
      }
    }
    .product {
      .product-box {
        .product-common .des-box {
          h3 {
            font-size: 18px;
            margin-bottom: 10px;
          }
          p {
            font-size: 12px;
            margin: 10px 0;
          }
          a {
            font-size: 12px;
            padding: 8px 15px;
          }
        }
        .express {
          padding: 5px 5px 2.5px;
          .des-box {
            margin-right: 5px;
            .des {
              padding: 4% 4% 0 0;
            }
          }
        }
        .ultra {
          padding: 2.5px 5px 5px;
          .des-box {
            margin-left: 5px;
            .des {
              padding: 4% 0 0 4%;
            }
          }
        }
      }
    }
    .choice {
      padding: 40px 0;
      .choice-box {
        width: 100%;
        h2 {
          font-size: 26px;
        }
        .choice-title {
          font-size: 16px;
        }
        .choice-dec {
          font-size: 12px;
        }
      }
    }
    .support {
      padding: 40px 0;
      .support-box {
        width: 100%;
        h2 {
          font-size: 30px;
        }
      }
    }
    .about-us {
      padding: 40px 0;
      .des-box {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        .des {
          h2 {
            font-size: 26px;
          }
          p {
            font-size: 12px;
          }
        }
        .show-box {
          .show-list {
            width: 150px;
            height: 150px;
            font-size: 18px;
            .timer {
              margin-top: 40px;
              font-size: 26px;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 767px) {
    .banner {
      .des {
        top: 10%!important;
        h3 {
          margin: 0 0 10px;
          font-size: 20px;
        }
        p {
          margin: 10px 0;
          font-size: 14px;
        }
        a {
          margin-top: 10px;
          padding: 6px 15px;
          font-size: 12px;
        }
      }
    }
    .product {
      .product-box .product-common {
        display: block;
        padding: 0;
        border-bottom: 1px solid @border-color;
        &:nth-last-of-type(1) {
          border-bottom: none;
        }
        .des-box {
          width: 100%;
          text-align: left;
          margin: 0;
          .des {
            padding: 20px 0 20px 20px;
          }
          h3 {
            margin: 0 0 20px;
            font-size: 26px;
          }
          p {
            margin: 15px 0;
            font-size: 15px;
          }
        }
        .img-box {
          width: 100%;
        }
      }
    }
    .choice {
      padding: 40px 0;
      border-top: 5px solid @border-color;
      .choice-box{
        width: 100%;
        h2 {
          font-size: 26px;
          font-weight: normal;
        }
        .choice-reason{
          margin: 20px 10px 0;
        }
        .choice-title {
          font-size: 14px;
          line-height:20px;
          color: @base-color;
        }
        .choice-dec{
          font-size: 12px;
          line-height: 22px;
          color: #888;
        }
      }
    }
    .support {
      padding: 40px 0;
      .support-box {
        width: 100%;
        h2 {
          font-size: 26px;
        }
      }
    }
    .about-us {
      padding: 40px 0;
      .des-box {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        .des {
          h2 {
            font-size: 26px;
          }
          p {
            font-size: 12px;
          }
        }
        .show-box {
          .show-list {
            width: 100px;
            height: 100px;
            font-size: 18px;
            .timer {
              margin-top: 20px;
              font-size: 26px;
            }
          }
        }
      }
    }
  }

  /* 首页动画css */
  .fadeInLeft1 {
    animation: fadeInLeft 1.2s cubic-bezier(.5,1,.89,1);
    animation-fill-mode: forwards;
  }
  .fadeInLeft2 {
    animation: fadeInLeft .6s cubic-bezier(.5,1,.89,1);
    animation-fill-mode: forwards;
  }
  .fadeInLeft3 {
    animation: fadeInLeft 1.2s cubic-bezier(.5,1,.89,1);
    animation-fill-mode: forwards;
  }
  .fadeInLeft4 {
    animation: fadeInLeft .6s cubic-bezier(.5,1,.89,1);
    animation-fill-mode: forwards;
  }
  .fadeInRight1 {
    animation: fadeInRight .6s cubic-bezier(.5,1,.89,1);
    animation-fill-mode: forwards;
  }
  .fadeInRight2 {
    animation: fadeInRight 1.2s cubic-bezier(.5,1,.89,1);
    animation-fill-mode: forwards;
  }
  .fadeInRight3 {
    animation: fadeInRight .6s cubic-bezier(.5,1,.89,1);
    animation-fill-mode: forwards;
  }
  .fadeInRight4 {
    animation: fadeInRight 1.2s cubic-bezier(.5,1,.89,1);
    animation-fill-mode: forwards;
  }
</style>



// WEBPACK FOOTER //
// src/components/homePageNew.vue